<template>
  <div class="flex -space-x-2">
    <ArrowSmRightIcon />
    <ArrowSmLeftIcon />
  </div>
</template>

<script lang="ts" setup>
import { ArrowSmLeftIcon, ArrowSmRightIcon } from "@heroicons/vue/outline";
</script>
